import { validateEmail } from "./validateEmail";

export const UNSAFE_INPUT_MESSAGE =
  "Обнаружены недопустимые символы или фрагменты кода";

const DANGEROUS_PATTERNS = [
  /<script\b[\s\S]*?>[\s\S]*?<\/script>/gi,
  /<script\b/gi,
  /javascript:/gi,
  /on\w+\s*=/gi,
  /data:text\/html/gi,
  /<iframe/gi,
  /<object/gi,
  /<embed/gi,
  /<svg[\s\S]*?onload/gi,
  /expression\s*\(/gi,
  /vbscript:/gi,
];

function stripControlChars(value) {
  let result = "";

  for (let index = 0; index < value.length; index += 1) {
    const code = value.charCodeAt(index);

    if (
      code === 0x09 ||
      code === 0x0a ||
      code === 0x0d ||
      (code >= 0x20 && code !== 0x7f)
    ) {
      result += value[index];
    }
  }

  return result;
}

export function hasDangerousContent(value) {
  if (typeof value !== "string" || !value) {
    return false;
  }
  return DANGEROUS_PATTERNS.some((pattern) => {
    pattern.lastIndex = 0;
    return pattern.test(value);
  });
}

export function sanitizeEmailInput(value) {
  if (typeof value !== "string") {
    return "";
  }

  return stripControlChars(value)
    .replace(/[<>"'`\\;(){}[\]]/g, "")
    .replace(/[^a-zA-Z0-9@._+-]/g, "")
    .slice(0, 254);
}

export function sanitizePasswordInput(value) {
  if (typeof value !== "string") {
    return "";
  }

  return stripControlChars(value)
    .replace(/[<>"'`]/g, "")
    .slice(0, 128);
}

export function sanitizePlainText(value, maxLength = 500) {
  if (typeof value !== "string") {
    return "";
  }

  let sanitized = stripControlChars(value).slice(0, maxLength);

  if (hasDangerousContent(sanitized)) {
    DANGEROUS_PATTERNS.forEach((pattern) => {
      pattern.lastIndex = 0;
      sanitized = sanitized.replace(pattern, "");
    });
  }

  return sanitized.replace(/[<>"'`]/g, "");
}

export function validateEmailValue(value) {
  const sanitized = sanitizeEmailInput(value);

  if (!sanitized.trim()) {
    return { sanitized, error: "Укажите email" };
  }

  if (hasDangerousContent(value)) {
    return { sanitized, error: UNSAFE_INPUT_MESSAGE };
  }

  if (!validateEmail(sanitized)) {
    return { sanitized, error: "Введите корректный email" };
  }

  return { sanitized, error: null };
}

export function validatePasswordValue(value, emptyMessage = "Введите пароль") {
  const sanitized = sanitizePasswordInput(value);

  if (!sanitized) {
    return { sanitized, error: emptyMessage };
  }

  if (hasDangerousContent(value)) {
    return { sanitized, error: UNSAFE_INPUT_MESSAGE };
  }

  return { sanitized, error: null };
}
